var breakpoints = {
	xs: "0",
	sm: "375px",
	md: "768px",
	lg: "1024px",
	xl: "1280px"
};

export { breakpoints };
